export const navLinks = [
  { label: '最新入口', href: '#entries' },
  { label: '快捷导航', href: '#quick' },
  { label: '话题墙', href: '#topics' },
  { label: '热度榜单', href: '#ranking' },
  { label: '访问指南', href: '#guide' },
  { label: '常见问题', href: '#faq' },
];

export const noticeTicker =
  '撸撸射最新地址已同步更新 · 收藏本站，入口随时可查 · 建议同时保存 2 条以上备用线路 · 打不开先换线路再反馈';

export const heroStats = [
  { value: '128', label: '收录入口' },
  { value: '36', label: '今日更新' },
  { value: '99.2%', label: '线路可用率' },
  { value: '240万+', label: '累计导航' },
];

export const heroBadges = ['官网地址', '最新网址', '备用线路', '手机直达'];

export const quickEntries = [
  {
    id: 'q1',
    title: '官方主站入口',
    desc: '长期有效的首选线路，域名稳定、加载快速，日常访问建议从这里开始。',
    tag: '推荐',
    icon: 'ri-shield-star-line',
  },
  {
    id: 'q2',
    title: '最新地址同步',
    desc: '官方地址变更后第一时间更新，找不到入口时优先查看这一栏。',
    tag: '实时',
    icon: 'ri-links-line',
  },
  {
    id: 'q3',
    title: '备用线路集合',
    desc: '高峰时段自动分流，多条线路互相备份，一条不通立刻换下一条。',
    tag: '高可用',
    icon: 'ri-swap-box-line',
  },
  {
    id: 'q4',
    title: '移动端直达',
    desc: '针对手机浏览器优化，扫码或点击即可打开，无需额外安装。',
    tag: '便捷',
    icon: 'ri-smartphone-line',
  },
  {
    id: 'q5',
    title: '客户端下载',
    desc: '一键直达客户端入口，桌面端访问更稳定，减少反复找地址的麻烦。',
    tag: '省心',
    icon: 'ri-download-2-line',
  },
  {
    id: 'q6',
    title: '公告与通知',
    desc: '线路调整、域名更换都在这里同步，订阅后入口变动不再错过。',
    tag: '防走丢',
    icon: 'ri-megaphone-line',
  },
];

export const latestEntries = [
  {
    id: 'e1',
    name: '撸撸射官网',
    desc: '主域名入口，长期有效，日常访问的首选地址。',
    status: 'available',
    updated: '10 分钟前',
    heat: 98,
    tag: '主域',
  },
  {
    id: 'e2',
    name: '撸撸射最新地址',
    desc: '官方同步发布的最新访问地址，域名变动时优先使用。',
    status: 'available',
    updated: '32 分钟前',
    heat: 95,
    tag: '最新',
  },
  {
    id: 'e3',
    name: '撸撸射备用入口',
    desc: '高峰期分流线路，主站拥堵时切换体验更顺畅。',
    status: 'available',
    updated: '1 小时前',
    heat: 90,
    tag: '备用',
  },
  {
    id: 'e4',
    name: '撸撸射镜像站',
    desc: '海外线路镜像，跨区域访问更稳定，适合漫游环境。',
    status: 'available',
    updated: '2 小时前',
    heat: 87,
    tag: '镜像',
  },
  {
    id: 'e5',
    name: '撸撸射移动端',
    desc: '手机浏览器适配入口，扫码即达，操作更顺手。',
    status: 'available',
    updated: '3 小时前',
    heat: 82,
    tag: '移动',
  },
  {
    id: 'e6',
    name: '撸撸射导航页',
    desc: '聚合全部入口的导航聚合页，正在整理新版线路。',
    status: 'maintenance',
    updated: '5 小时前',
    heat: 74,
    tag: '聚合',
  },
];

export const topicTags = [
  { label: '撸撸射入口', size: 'lg' },
  { label: '撸撸射网址', size: 'lg' },
  { label: '撸撸射官网', size: 'md' },
  { label: '撸撸射最新地址', size: 'lg' },
  { label: '撸撸射导航', size: 'md' },
  { label: '备用线路', size: 'sm' },
  { label: '镜像站', size: 'sm' },
  { label: '手机入口', size: 'md' },
  { label: '防走丢', size: 'sm' },
  { label: '一键直达', size: 'md' },
  { label: '高速线路', size: 'sm' },
  { label: '实时更新', size: 'md' },
  { label: '官方公告', size: 'sm' },
  { label: '通道检测', size: 'sm' },
  { label: '打不开怎么办', size: 'md' },
  { label: '收藏夹', size: 'sm' },
  { label: '换域名', size: 'sm' },
  { label: '客服通道', size: 'sm' },
];

export const hotRankings = {
  tabs: [
    { key: 'today', label: '日榜' },
    { key: 'week', label: '周榜' },
    { key: 'all', label: '总榜' },
  ],
  today: [
    { rank: 1, name: '撸撸射官网', desc: '主域长期入口', heat: 9862, trend: 'up' },
    { rank: 2, name: '撸撸射最新地址', desc: '官方实时同步', heat: 9340, trend: 'up' },
    { rank: 3, name: '撸撸射备用入口', desc: '高峰分流线路', heat: 8721, trend: 'flat' },
    { rank: 4, name: '撸撸射导航页', desc: '入口聚合总览', heat: 8105, trend: 'down' },
    { rank: 5, name: '撸撸射镜像站', desc: '跨区域稳定访问', heat: 7624, trend: 'up' },
    { rank: 6, name: '撸撸射移动端', desc: '手机扫码直达', heat: 7180, trend: 'flat' },
  ],
  week: [
    { rank: 1, name: '撸撸射最新地址', desc: '本周搜索最热', heat: 62480, trend: 'up' },
    { rank: 2, name: '撸撸射官网', desc: '稳定访问首选', heat: 59120, trend: 'flat' },
    { rank: 3, name: '撸撸射入口', desc: '新用户必看', heat: 54370, trend: 'up' },
    { rank: 4, name: '撸撸射备用入口', desc: '线路切换更省心', heat: 48905, trend: 'down' },
    { rank: 5, name: '撸撸射网址', desc: '收藏常用地址', heat: 44210, trend: 'up' },
    { rank: 6, name: '撸撸射导航', desc: '一站式入口汇总', heat: 39860, trend: 'flat' },
  ],
  all: [
    { rank: 1, name: '撸撸射官网', desc: '累计导航量第一', heat: 986240, trend: 'flat' },
    { rank: 2, name: '撸撸射最新地址', desc: '长期高频访问', heat: 921570, trend: 'up' },
    { rank: 3, name: '撸撸射入口', desc: '新手收藏最多', heat: 874330, trend: 'up' },
    { rank: 4, name: '撸撸射网址', desc: '稳定收录入口', heat: 812640, trend: 'flat' },
    { rank: 5, name: '撸撸射备用入口', desc: '备用线路常青款', heat: 766890, trend: 'down' },
    { rank: 6, name: '撸撸射导航', desc: '聚合页访问稳定', heat: 701520, trend: 'flat' },
  ],
};

export const guideSteps = [
  {
    step: '01',
    title: '先收藏本站',
    desc: '把导航页加入浏览器收藏夹，地址无论怎么变，回到这里就能重新找到入口。',
    icon: 'ri-bookmark-3-line',
  },
  {
    step: '02',
    title: '按顺序试线路',
    desc: '优先点击官网主域，其次最新地址、备用线路，逐条尝试，总有一条能打开。',
    icon: 'ri-route-line',
  },
  {
    step: '03',
    title: '排查访问环境',
    desc: '若都打不开，先切换网络或刷新 DNS，再重新打开页面，多数情况可恢复。',
    icon: 'ri-refresh-line',
  },
  {
    step: '04',
    title: '保存最新地址',
    desc: '把当前能用的地址记下来，定期回访导航页，避免下次又到处找入口。',
    icon: 'ri-inbox-archive-line',
  },
];

export const faqs = [
  {
    q: '撸撸射入口打不开怎么办？',
    a: '先换一条线路：官网主域、最新地址、备用线路依次尝试。若全部无法打开，建议切换网络环境或刷新 DNS 后重试，通常可以恢复访问。',
  },
  {
    q: '最新地址多久更新一次？',
    a: '一旦官方域名发生变动，导航页会第一时间同步最新地址，正常情况下数小时内完成更新，你只需回到本页即可看到可用入口。',
  },
  {
    q: '为什么需要保存多条备用线路？',
    a: '不同线路在不同网络下的表现不一样，高峰期也可能出现拥堵。同时保存官方网站、最新地址和多条备用线路，才能保证始终有可用的入口。',
  },
  {
    q: '手机端怎么快速访问？',
    a: '直接使用手机浏览器打开本导航页即可，点击移动端入口就能访问。建议添加到手机主屏幕，下次一键打开，不用再手动输入网址。',
  },
  {
    q: '收藏本站有什么好处？',
    a: '站点会持续更新撸撸射官网地址、最新网址和导航信息。收藏后每次找入口都会快很多，也不会因为域名更换而彻底迷路。',
  },
];

export const footerGroups = [
  {
    title: '快速导航',
    links: ['最新入口', '快捷导航', '话题墙', '热度榜单'],
  },
  {
    title: '入口相关',
    links: ['撸撸射官网', '撸撸射最新地址', '备用线路', '移动端入口'],
  },
  {
    title: '帮助支持',
    links: ['访问指南', '常见问题', '通道检测', '联系我们'],
  },
];

export const footerNote =
  '本站为撸撸射入口导航站点，仅提供网址导航与访问方式整理，页面内容为信息展示，不参与任何交易与服务提供。';